/**
 * Which page a caller lands on when they open the app WITHOUT naming one.
 *
 * Two rules, and the second is the one that is easy to get wrong:
 *
 *   1. EVERYONE lands on Home (ACOP-140). The new landing page is the live experience — there is no
 *      switch and no role in the decision any more. (History: ACOP-70 landed employees on Home by
 *      role; 2026-08-28 reversed that so everyone landed on Copilot with Beta Preview choosing Home;
 *      2026-10-13 made the new pages the default for all.)
 *   2. ONLY a path-less request resolves to a default. A deep link is NEVER rewritten to a landing
 *      page: someone following a notification link to /support-tickets?id=... must arrive there,
 *      not be bounced through a landing page that throws away where they were going.
 *
 * Pure and free of React/react-router imports so the rules can be unit-tested directly — the same
 * reasoning as utils/nav.ts.
 */

export const HOME_PATH = "/home";

/**
 * The default landing page: Home, for everyone.
 *
 * ACOP-140: the new landing page is the live experience (David, 2026-10-13), so a path-less request
 * no longer depends on a switch or a role. A constant, deliberately — the previous signature took
 * the resolved Beta Preview state and landed on /copilot when it was off.
 */
export function defaultLandingPath(): string {
  return HOME_PATH;
}

/**
 * True for the only request shape that may be redirected to a default: no path at all.
 *
 * Tolerates the empty string as well as "/" so a caller that hands over a bare origin is treated
 * the same way. Every other pathname — including "/home" and "/copilot" themselves — is an
 * explicit destination and is left exactly as asked for.
 */
export function isPathlessRequest(pathname: string): boolean {
  return pathname === "" || pathname === "/";
}
